<div style="width: 100%; height: 70%; display: flex; flex-direction: column; justify-content: space-evenly;">
  <div style="display: flex; flex-direction: row; align-items: center; gap:5px; padding: 1rem;">
    <mat-icon  
    style="margin-block: 1rem; cursor: pointer"
    >
    near_me
    </mat-icon>
    <h1 style="margin-block: 0;">Navega por SAMA APP</h1>
</div>
  <mat-card *ngFor="let card of cards"
      [style.border]="'2px solid #007BFF'"   
      style="padding: 1rem; margin-bottom: 10px; margin-top: 1rem; cursor: pointer; width: 100%;"
      [routerLink]="card.route"
    >
      <div style="display: flex;">
        <div mat-card-avatar class="example-header-image">
          <mat-icon>{{card.icon}}</mat-icon>
        </div>
        <div style="width: 80%;">
          <mat-card-title>{{card.title}}</mat-card-title>
          <mat-card-subtitle>{{card.subtitle}}</mat-card-subtitle>
        </div>
        <h1 *ngIf="card.quantity">+ {{card.quantity}}</h1>
       
      </div>
    </mat-card>
</div>